module.exports = __webpack_public_path__ + "img/S__8126511.9b062895.jpg";